module.exports = __webpack_public_path__ + "img/icon-ranking-3@2x.89ed1b35.png";